import { useContext } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { TenantContext } from "../../context/tenant/TenantContext";
import DOMPurify from "dompurify";
import "./tenantterms.css";
import { Link, useLocation } from "react-router-dom";
import { LanguageContext } from "../../context/language/LanguageContext";
import TermsAndConditionsAdditional from "./TermsAndConditionsAdditional";

export default function TermsAndConditions() {
  const { language } = useContext(LanguageContext);

  const { tenant } = useContext(TenantContext);
  const url = useLocation().pathname.split("/")[1];

  return (
    <div className="container">
      <div className="row mt-5">
        <div className="col">
          <Link
            to={`/${url}`}
            className="text-dark mb-4 d-inline-block text-decoration-none"
            style={{ fontSize: "30px" }}
          >
            <i className="bi bi-chevron-left"></i>{" "}
            {tenant?.termsandconditionsdisplay}
          </Link>
        </div>
      </div>
      <div className="row mt-3">
        <div className="col">
          {
            <div dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(
                tenant?.tenanttermsandconditions
              ),
            }}>
            </div>
          }
        </div>
      </div>
    </div>
  );
}
